import EmptyState from '../EmptyState'

const ViewerTestCaseNoParameters = () =>
  <EmptyState
    hasPadding={false}
    title='No parameters found'
  />

export default ViewerTestCaseNoParameters
